import { IItemDto } from '../lib/types';

export { default as listDims } from './list-dims.json';

export { kExp, kLvl } from '~packages/epk-front-shared/config';

export const kId = 'code' as keyof IItemDto;
